@if (status() !== 'inactive') {
  <button
    blazeBarButton="secondary"
    (click)="configTriggers.emit()"
    data-cy="BlazeTable:Context:EditTriggers"
  >
    WORKFLOWS
    @switch (status()) {
      @case ('active') {
        <span class="circle count">{{ enabledCount() }}</span>
      }
      @case ('paused') {
        <span class="circle paused"><mat-icon svgIcon="icon_pause_8" /></span>
      }
      @case ('error') {
        <span class="circle error"><mat-icon svgIcon="icon_pause_8" /></span>
      }
    }
  </button>
}
